// Libraries
import React from 'react';

// Supermove
import {UrlFiltersType, useDebouncedCallback} from '@supermove/hooks';

// App
import SearchBar from '@shared/design/components/SearchBar';
import {OfficeMoversContentV2FiltersType} from 'modules/Organization/Settings/Staff/OrganizationSettingsStaffMoversContentV2';

const OfficeMoversSearch = ({
  urlFilters,
}: {
  urlFilters: UrlFiltersType<OfficeMoversContentV2FiltersType>;
}) => {
  const handleChangeSearch = useDebouncedCallback(
    (input) => urlFilters.handleUpdate({searchQuery: input}),
    250,
  );

  return (
    <SearchBar
      onChangeText={handleChangeSearch}
      placeholder='Search by name, phone number, email, or position'
      containerStyle={{flex: 1}}
      style={{flex: 1}}
      defaultValue={urlFilters.get('searchQuery')}
      isClearable
      isResponsive
    />
  );
};

export default OfficeMoversSearch;
